import { useState, useEffect, useCallback } from 'react'
export interface Reminder {
  id: string
  text: string
  datetime: string // ISO string
  recurring?: 'daily' | 'weekly' | 'monday'
  snoozedUntil?: string
  dismissed: boolean
}
const STORAGE_KEY = 'vsm_reminders'
const DEFAULT_REMINDERS: Reminder[] = [
  {
    id: 'r1',
    text: 'Revisar PRs del equipo',
    datetime: new Date(Date.now() + 3600000).toISOString(),
    // 1 hour from now
    recurring: 'daily',
    dismissed: false,
  },
  {
    id: 'r2',
    text: 'Preparar reporte semanal',
    datetime: new Date(Date.now() + 86400000).toISOString(),
    // Tomorrow
    recurring: 'weekly',
    dismissed: false,
  },
  {
    id: 'r3',
    text: 'Actualizar Jira',
    datetime: new Date(Date.now() - 3600000).toISOString(),
    // 1 hour ago (overdue)
    dismissed: false,
  },
]
export function useReminders() {
  const [reminders, setReminders] = useState<Reminder[]>(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY)
      if (stored) return JSON.parse(stored)
    } catch (e) {
      console.error('Error loading reminders', e)
    }
    return DEFAULT_REMINDERS
  })
  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(reminders))
  }, [reminders])
  const addReminder = useCallback(
    (reminder: Omit<Reminder, 'id' | 'dismissed'>) => {
      const newReminder: Reminder = {
        ...reminder,
        id: Math.random().toString(36).substring(2, 9),
        dismissed: false,
      }
      setReminders((prev) => [...prev, newReminder])
    },
    [],
  )
  const dismissReminder = useCallback((id: string) => {
    setReminders((prev) =>
      prev.map((r) =>
        r.id === id
          ? {
              ...r,
              dismissed: true,
            }
          : r,
      ),
    )
  }, [])
  const snoozeReminder = useCallback((id: string, minutes: number) => {
    setReminders((prev) =>
      prev.map((r) => {
        if (r.id !== id) return r
        const snoozedUntil = new Date(
          Date.now() + minutes * 60000,
        ).toISOString()
        return {
          ...r,
          snoozedUntil,
          dismissed: false,
        }
      }),
    )
  }, [])
  const removeReminder = useCallback((id: string) => {
    setReminders((prev) => prev.filter((r) => r.id !== id))
  }, [])
  return {
    reminders,
    addReminder,
    dismissReminder,
    snoozeReminder,
    removeReminder,
  }
}
